$(document).ready(function () {
  $('.page-navigation .next a').html('»');
  $('.page-navigation .previous a').html('«');
});